export default {
  colors: {
    colorPrimary: '#F7931A',
    colorPrimaryDark: '#D88117',
    colorSuccess: '#5CB85C',
    colorError: '#DC3543',
    colorGray: '#808080',
    colorLightWhite: 'rgba(255, 255, 255, 0.2)',
    colorBlack: '#000',
    colorWhite: '#FFF',
  },
  style: {
    borderRadius: '5rem',
    borderRadiusLight: '0.8rem',
  },
};
